var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApostrophe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.26997 4.31966L8.66077 3.30005C4.44319 6.38436 2.1001 10.1314 2.1001 13.2157C2.1001 16.1981 4.11516 17.6 5.82562 17.6C7.98127 17.6 9.50428 15.6118 9.50428 13.5216C9.50428 11.7628 8.47332 10.2589 7.09089 9.69809C6.69257 9.54515 6.31767 9.4177 6.31767 8.67848C6.31767 7.73534 6.95031 6.33338 9.26997 4.31966ZM18.5721 4.31966L17.9629 3.30005C13.7921 6.38436 11.4022 10.1314 11.4022 13.2157C11.4022 16.1981 13.4641 17.6 15.1746 17.6C17.3537 17.6 18.9001 15.6118 18.9001 13.5216C18.9001 11.7628 17.8457 10.2589 16.4164 9.69809C16.0181 9.54515 15.6666 9.4177 15.6666 8.67848C15.6666 7.73534 16.3227 6.33338 18.5721 4.31966Z",
    fill: "#3F7FAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApostrophe);
export default __webpack_public_path__ + "static/media/Apostrophe.f5cfc2a80ed7924198c95be1fa202ffa.svg";
export { ForwardRef as ReactComponent };